/**
 * Facebook Widget behaviour. 
 */

(function (Drupal, $, twttr) {
  "use strict";

  Drupal = Drupal || {};
  
  /**
   * Init Facebook Widget
   */
  function init () {
    var js, fjs = document.getElementsByTagName('script')[0];
    if (document.getElementById('facebook-jssdk')) {return;}
    js = document.createElement('script'); js.id = 'facebook-jssdk';
    js.src = '//connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  }

  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.facebookWidget.attach}}
   */

  Drupal.behaviors.facebookWidget = {
    attach: function (context, settings) {

      jQuery('body').once('facebook', function() {

        window.fbAsyncInit = function() {

          setTimeout(function() {
            FB.init({
              xfbml      : true,
              version    : 'v2.11'
            });
          }, 500);
        };

        init();



      })

    }
  }

})(Drupal, jQuery);
